(() => {
  const timelines = new Set();
  let queued = false;
  function sizeTimeline(timeline) {
    if (!timeline.isConnected) { timelines.delete(timeline); return; }
    const slider = timeline.querySelector('.timeline__slider');
    if (!slider) return;
    const slides = [...slider.querySelectorAll('.timeline__slide')];
    const width = slider.clientWidth;
    if (!width) return;
    let height = 0;
    for (const slide of slides) {
      const previous = { hidden: slide.hidden, style: slide.getAttribute('style') };
      slide.hidden = false;
      slide.style.cssText += ';position:absolute;visibility:hidden;display:grid!important;pointer-events:none;width:' + width + 'px;';
      height = Math.max(height, slide.getBoundingClientRect().height);
      slide.hidden = previous.hidden;
      if (previous.style === null) slide.removeAttribute('style');
      else slide.setAttribute('style', previous.style);
    }
    slider.style.minHeight = height + 'px';
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; timelines.forEach(sizeTimeline); });
  }
  function init(root = document) {
    root.querySelectorAll('.pn-home-timeline .timeline').forEach(timeline => {
      if (timelines.has(timeline)) return;
      timelines.add(timeline);
      timeline.querySelectorAll('img').forEach(img => {
        if (!img.complete) img.addEventListener('load', schedule, { once: true });
      });
    });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', schedule);
  addEventListener('resize', schedule, { passive: true });
  if (document.fonts) document.fonts.ready.then(schedule);
})();

(() => {
  const lockClass = 'pn-home-menu-open';
  const inertStates = new Map();
  function isolate(menu) {
    for (let node = menu; node && node !== document.body; node = node.parentElement) {
      for (const sibling of node.parentElement.children) {
        if (sibling === node || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) continue;
        if (!inertStates.has(sibling)) inertStates.set(sibling, sibling.inert);
        sibling.inert = true;
      }
    }
  }
  function release() {
    for (const [node, previous] of inertStates) node.inert = previous;
    inertStates.clear();
  }
  function syncLock() {
    const menu = document.querySelector('.pn-parity-header .an-mobile-menu[open]');
    document.documentElement.classList.toggle(lockClass, !!menu);
    if (menu) isolate(menu); else release();
  }
  function visibleLinks(details) {
    return [...details.querySelectorAll(':scope > ul a[href]')].filter(el => el.getClientRects().length);
  }
  function setSubmenu(details, open, focus = false) {
    details.open = open;
    const summary = details.querySelector(':scope > summary');
    summary.setAttribute('aria-expanded', String(open));
    if (focus) summary.focus();
  }
  function init(root = document) {
    root.querySelectorAll('[data-pn-navigation]').forEach(nav => {
      if (nav.dataset.pnNavigationBound) return;
      nav.dataset.pnNavigationBound = 'true';
      nav.querySelectorAll('details').forEach(details => {
        const summary = details.querySelector(':scope > summary');
        summary.setAttribute('aria-expanded', String(details.open));
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) nav.querySelectorAll('details[open]').forEach(other => {
            if (other !== details) setSubmenu(other, false);
          });
        });
      });
      nav.addEventListener('keydown', event => {
        const details = event.target.closest('details');
        if (!details || !nav.contains(details)) return;
        const summary = details.querySelector(':scope > summary');
        if (event.key === 'Escape' && details.open) {
          event.preventDefault(); event.stopImmediatePropagation();
          setSubmenu(details, false, true); return;
        }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        if (!details.open && event.target !== summary) return;
        event.preventDefault(); event.stopImmediatePropagation();
        setSubmenu(details, true);
        const links = visibleLinks(details);
        if (!links.length) return;
        const index = links.indexOf(document.activeElement);
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1 : event.key === 'ArrowDown' ? (index + 1) % links.length : (index <= 0 ? links.length - 1 : index - 1);
        links[next].focus();
      });
      if (nav.classList.contains('an-navigation--desktop')) {
        nav.addEventListener('focusout', () => requestAnimationFrame(() => {
          nav.querySelectorAll('details[open]').forEach(details => {
            if (!details.contains(document.activeElement)) setSubmenu(details, false);
          });
        }));
      }
    });
    root.querySelectorAll('.pn-parity-header .an-mobile-menu').forEach(menu => {
      if (menu.dataset.pnHomeMenuBound) return;
      menu.dataset.pnHomeMenuBound = 'true';
      const panel = menu.querySelector('.an-mobile-panel');
      const trigger = menu.querySelector(':scope > summary');
      const close = (restoreFocus = true) => {
        menu.open = false;
        menu.querySelectorAll('.an-navigation details[open]').forEach(details => setSubmenu(details, false));
        trigger.setAttribute('aria-expanded', 'false');
        syncLock();
        if (restoreFocus) trigger.focus();
      };
      let entryFocus;
      trigger.setAttribute('aria-expanded', String(menu.open));
      menu.addEventListener('toggle', () => {
        entryFocus?.abort();
        trigger.setAttribute('aria-expanded', String(menu.open));
        if (!menu.open) menu.querySelectorAll('.an-navigation details[open]').forEach(details => setSubmenu(details, false));
        syncLock();
        if (menu.open) {
          const closeButton = panel.querySelector('[data-an-menu-close]');
          closeButton?.focus({ preventScroll: true });
          if (document.activeElement !== trigger) return;
          const pending = new AbortController();
          entryFocus = pending;
          // Relinquish deferred focus as soon as the visitor acts or focus moves.
          ['keydown', 'pointerdown', 'focusin'].forEach(type => {
            document.addEventListener(type, () => pending.abort(), {
              capture: true, once: true, signal: pending.signal
            });
          });
          requestAnimationFrame(() => {
            if (pending.signal.aborted) return;
            // Native details may still reject focus during its first reveal after resize.
            const opening = panel.getAnimations({ subtree: true }).filter(animation =>
              Number.isFinite(animation.effect?.getComputedTiming().endTime));
            Promise.allSettled(opening.map(animation => animation.finished)).then(() => {
              if (pending.signal.aborted) return;
              pending.abort();
              if (menu.isConnected && menu.open && document.activeElement === trigger) {
                closeButton?.focus({ preventScroll: true });
              }
            });
          });
        }
      });
      menu.addEventListener('click', event => {
        if (event.target.closest('[data-an-menu-close]') || (menu.open && event.target === menu)) close();
        else if (event.target.closest('.an-mobile-panel a[href]')) close(false);
      });
      menu.addEventListener('keydown', event => {
        if (!menu.open) return;
        if (event.key === 'Escape') {
          event.preventDefault(); event.stopImmediatePropagation(); close(); return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [...panel.querySelectorAll('button:not([disabled]),a[href],summary')]
          .filter(el => {
            if (!el.getClientRects().length || getComputedStyle(el).visibility === 'hidden') return false;
            for (let parent = el.parentElement; parent && parent !== panel; parent = parent.parentElement) {
              if (parent.matches('details:not([open])') && parent.firstElementChild !== el) return false;
            }
            return true;
          });
        const first = focusable[0], last = focusable.at(-1);
        if (!first) return;
        if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
          event.preventDefault(); first.focus();
        }
        event.stopPropagation();
      });
    });
    syncLock();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(syncLock));
  addEventListener('resize', () => {
    if (innerWidth >= 1150) document.querySelectorAll('.pn-parity-header .an-mobile-menu[open]').forEach(menu => { menu.open = false; });
    syncLock();
  }, { passive: true });
})();
